export interface SideFilterOptions {
    proofTypes?:string[], // proofTypes
    status?:string[], // active
    statusDefault?:string[], // active
    genres?:string[], // genres
    roles?:string[], // genres
    accountTypes?:string[], // isDependent
    ages?:string[], // ageRanges
    companyDepartments?:string[],
    companyRoles?:string[],
    companyHealthPlans?:string[],
    companyLocalities?:string[]
    vaccines?:string[],
    riskLevels?:string[], // riskLevels (Flow Evolução, applied on screen)
    areas?:string[], // areaIds (Flow Evolução, applied on screen)
    // TODO o quê mais ?

  }

  export interface FilterItem {
      label:string;
      value:string;
  }

  export const FILTER_PROOF_TYPES:FilterItem[] = [
    {value:"Atestado", label:"Atestado"},
    {value:"Carteira de Vacinação", label:"Carteira de Vacinação"},
    {value:"Carteirinha do Plano de Saúde", label:"Carteirinha do Plano de Saúde"},
    {value:"Recibos", label:"Recibos"},
    {value:"Nota Fiscal", label:"Nota Fiscal"},
    {value:"Outros", label:"Outros"}
  ];

  export const FILTER_STATUS:FilterItem[] = [
    {value:"registered", label:"Todos os cadastrados"}, // Todos os cadastrados
    {value:"suspended", label:"Acesso suspenso"}, // Acesso suspenso
  ];

  export const FILTER_STATUS_DEFAULT:FilterItem[] = [
    {value:"ativos", label:"Ativos"}, // Todos os cadastrados
    {value:"inativos", label:"Inativos"}, // Acesso suspenso
  ];

  // Gênero
  export const FILTER_GENRES:FilterItem[] = [
    {value:"M", label:"Masculino"}, // Masculino
    {value:"F", label:"Feminino"}, // Feminino
    {value:"HT", label:"Homem Transgênero"}, // Homem Transgênero
    {value:"MT", label:"Mulher Transgênero"}, // Mulher Transgênero
  ];

  // Gênero no Flow: mesmos valores, rótulos como no protótipo aprovado
  export const FLOW_FILTER_GENRES:FilterItem[] = [
    {value:"M", label:"Masculino"},
    {value:"F", label:"Feminino"},
    {value:"HT", label:"Homem transgênero"},
    {value:"MT", label:"Mulher transgênero"},
  ];

  // Profile
  export const FILTER_ROLES:FilterItem[] = [
    {value:"ADMIN", label:"Admin"},
    {value:"PROVIDER", label:"Provider"},
    {value:"PROFESSIONAL", label:"Professional"},
    {value:"USER_MANAGEMENT", label:"Gerente de usuário"},
    {value:"DOCTOR", label:"Doutor"},
  ];

  // Conta
  export const FILTER_ACCOUNT_TYPES:FilterItem[] = [
    {value:"holder", label:"Titular"}, // Titular
    {value:"dependent", label:"Dependente"} // Dependente
  ];

  // Faixa Etária
  export const FILTER_AGES:FilterItem[] = [
    {value:"MINOR", label:"menor de 18 anos"}, // menor de 18 anos
    {value:"BETWEEN_18_25", label:"18 a 25 anos"},// 18 a 25 anos
    {value:"BETWEEN_26_32", label:"26 a 32 anos"}, // 26 a 32 anos
    {value:"BETWEEN_33_45", label:"33 a 45 anos"}, // 33 a 45 anos
    {value:"BETWEEN_46_65", label:"46 a 65 anos"}, // 46 a 65 anos
    {value:"OVER_65", label:"mais de 65 anos"}// mais de 65 anos
  ];

  // Risco no Flow (Evolução): nível do departamento no último ciclo do intervalo, filtrado na tela
  export const FLOW_FILTER_RISKS:FilterItem[] = [
    {value:"ALTO", label:"Alto"},
    {value:"MEDIO", label:"Médio"},
    {value:"BAIXO", label:"Baixo"},
  ];

  // Faixa etária no Flow: só as faixas do questionário (protótipo aprovado)
  export const FLOW_FILTER_AGES:FilterItem[] = FILTER_AGES.filter(age => age.value !== "MINOR" && age.value !== "OVER_65");
